import axios from "axios"
import Server from "util/Server"

export const obtenerDataTelemetriaDashboard = async (empresa_id: number) => {
     try {

          const { data } = await axios.get(`${Server.host}${Server.puerto_reporte_service}/api/telemetria/dashboard/${empresa_id}`, { headers: { Authorization: `Bearer ${Server.obtenerToken()}` } })
          if (!data.data) {
               return {
                    status: 400,
                    mensaje: 'No se han encontrado datos',
                    data: []
               }
          }

          return data
     } catch (error) {
          console.log('[ERROR TELEMETRIA SERVICE] ERROR : ', error)
          return {
               status: 500,
               mensaje: 'No se han encontrado datos',
               data: []
          }
     }
}